import { makeStyles } from '@mui/styles';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { GET_SMARTINSIGHT_REPORTS_ENDPOINT } from '../../constants/SmartInsightConstants';
import { SMART_INSIGHT, SMART_INSIGHT_REPORTS } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import SavedSearchesTable from '../SavedSearchesTable';

const useStyles = makeStyles({
  sectionTitle: {
    width: 200,
    height: 24,
    fontSize: 16,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: '#000',
    paddingTop: 10,
  },
  tableWrapper: {
    '& thead > tr > input': {
      height: 32,
    },
    '& thead tr:nth-child(2) th div': {
      marginBottom: 0,
    },
  },
  headerWarapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: 60,
    padding: '0 15px',
  },
  modal: {
    maxWidth: 980,
  },
});

const ItemsTable = ({ entityName, initialSearchName, itemTitle, customCell, extraColumns }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const { pathname, search } = useLocation();

  const title = translateString(itemTitle);

  const fullRouteName = `${pathname}${search}`;
  const isSmartInsightReportsDashboard =
    fullRouteName === SMART_INSIGHT || fullRouteName === SMART_INSIGHT_REPORTS;

  return (
    <div className={classes.tableWrapper}>
      <SavedSearchesTable
        entityName={entityName}
        initialSearchName={initialSearchName}
        title={translateString(title)}
        rowsPerPageOptions={[10, 50, 100]}
        extraColumns={extraColumns}
        enableSorting
        customCell={customCell}
        showSearchSelector={false}
        showFilters
        enableSaving
        customEndpointName={isSmartInsightReportsDashboard ? GET_SMARTINSIGHT_REPORTS_ENDPOINT : ''}
      />
    </div>
  );
};

export default ItemsTable;
